/**
 * @deprecated use zzm-base
 */
export interface IconProps {
  color?: string;
  size?: number; //TODO: update type to IconSize when all icons are updated
  onClick?: () => void;
  cursor?: string;
}

/**
 * @deprecated use zzm-base
 */
const IconSizes = <const>[16, 20, 24, 32, 40];
/**
 * @deprecated use zzm-base
 */
export type IconSize = (typeof IconSizes)[number];

// TODO remove the | number ASAP
/**
 * @deprecated use zzm-base
 * @param size
 */
export const getStrokeWidth = (size: IconSize | number) => {
  switch (size) {
    case 16:
      return 2;
    case 20:
      return 1.68;
    case 24:
      return 1.5;
    case 32:
      return 1.2;
    case 40:
      return 1.02;
  }
};
